import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=1e621111"
import script from "./InfoBar.vue?vue&type=script&lang=js"
export * from "./InfoBar.vue?vue&type=script&lang=js"
import style0 from "./InfoBar.vue?vue&type=style&index=0&id=1e621111&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports